module.exports = __webpack_public_path__ + "img/amer.4decf15.svg";